import React, { useState, useEffect } from 'react';
import EventCard from '../components/EventCard';
import HeroSlider from '../components/HeroSlider';
import { eventService } from '../services/api.service';
import './MainPage.css';
import { FancyTitle } from '../components/styles/Title.styled';

const MainPage = () => {
    const [events, setEvents] = useState([]);
    const [featuredEvents, setFeaturedEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            console.log('MainPage: Starting to fetch data');
            try {
                // First, get all events
                const eventsResponse = await eventService.getAllEvents();
                console.log('All events response:', eventsResponse);

                if (Array.isArray(eventsResponse)) {
                    setEvents(eventsResponse);
                    // Get featured events (events with 'featured' tag)
                    const featured = eventsResponse.filter(event => 
                        event.tags && event.tags.includes('featured')
                    );
                    setFeaturedEvents(featured.length > 0 ? featured : eventsResponse.slice(0, 5));
                    console.log('Featured events set:', featured);
                } else {
                    throw new Error('Invalid response format');
                }

            } catch (err) {
                console.error('MainPage: Error fetching events:', err);
                setError(`Error: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    console.log('Current state:', { events, featuredEvents, loading, error });

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Etkinlikler yükleniyor...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <p>Hata: {error}</p>
                <button onClick={() => window.location.reload()}>
                    Tekrar Dene
                </button>
            </div>
        );
    }

    return (
        <div className="main-page">
            {featuredEvents.length > 0 && (
                <>
                    <div className="hero-section">
                        <HeroSlider 
                            events={featuredEvents.map(event => ({
                                ...event,
                                id: event._id,
                                image_url: event.image_url,
                                title: event.title,
                                description: event.description
                            }))} 
                        />
                    </div>
                </>
            )}
            <div className="content">
                <FancyTitle><span>Etkinlikler</span></FancyTitle>
                <div className="events-grid">
                    {events.map(event => (
                        <EventCard 
                            key={event._id}
                            event={{
                                id: event._id,
                                title: event.title,
                                image_url: event.image_url
                            }} 
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MainPage;
